require("axios");
require("vue");

import { createApp } from 'vue';
import axios from 'axios';

// js call method
function gyoumu_api_process(tgt_dom_id, api_prm){

    const app_data = {
        data() {
            return {
                info: {},
                loading: true,
                errored: false,

                selected_url_name: api_prm.selected_url_name,
                pages: api_prm.pages,
                page_select_options: api_prm.page_select_options,
                view_pages: [],
            }
        },
        methods: {
            updatePageBody: function(){
                var vueObj = this;
                const url_name = vueObj.selected_url_name;

                if(url_name === 'all'){
                    vueObj.view_pages = vueObj.pages;
                }
                else{
                    const tgt_page = vueObj.pages.find(chk_page => chk_page.url_name === vueObj.selected_url_name);
                    if(tgt_page){
                        vueObj.view_pages = [tgt_page];
                    }
                    else{
                        vueObj.view_pages = [];
                    }
                }

                vueObj.loading = false;
            },
        },
        computed: {
        },
        mounted: function(){
            var vueObj = this;
            vueObj.updatePageBody();
        }
    };
    const app = createApp(app_data).mount(tgt_dom_id);
}

// ここが有効になればグローバルに使えるようになる。
window.gyoumu_api_process = gyoumu_api_process;
